import React from 'react';

const TransactionalFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17 6H4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.33398 14L16.5007 14" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.6523 11L16.8265 14.1742L13.6523 17.3484"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.17387 3.00004L2.99967 6.17424L6.17387 9.34843"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TransactionalFilterIcon;
